export const APP_NAMES = ['phantom', 'wraith', 'dawn', 'cullinan'];

export const APPS_CONTENT = {
  phantom: {
    description: `Flagship AIO software supporting a range of sites such as US Footsites, Yeezy Supply, Finishline, Supreme, & more.`,
    link: 'https://ghostaio.com',
  },
  dawn: {
    description: `Dawn is a private community for dedicated sneakerheads. Stop paying for services that don't satisfy your expectations. Bringing you custom monitors, exclusive information, detailed release setup, complimentary Phantom and Wraith licenses, and much more.`,
    link: 'https://dawned.gg',
  },
  wraith: {
    description: `A versatile desktop toolkit designed to streamline release setup for sneaker bot users of all types. Perfect for enhancing your botting experience with Phantom and many other bots!`,
    link: 'https://wraith.gg',
  },
  cullinan: {
    description: `A service that sells proxies optimized for Phantom’s target sites, making it easy for our customers to source vetted proxies for every release. Premium proxies with unbeatable speeds - the perfect combination for destroying releases with Phantom and Wraith.`,
    link: 'https://cullinan.gg',
  },
};
